import { DataTypeColumn } from 'components/DataExpansionComponents/Common/commonColumnHelpers'

export const SEQUENCE_COLUMNS: Record<string, DataTypeColumn> = {
  seq_membership_status: {
    header: 'Status',
    group: 'Sequencing',
  },
  seq_scheduled_emails: {
    header: 'Scheduled Emails',
    group: 'Sequencing',
  },
  seq_emails_sent: {
    header: 'Sent',
    group: 'Sequencing',
  },
  seq_replies: {
    header: 'Replies',
    group: 'Sequencing',
  },
  seq_last_email: {
    header: 'Last Email',
    group: 'Sequencing',
  },
  seq_sequence_step: {
    header: 'Sequence Step',
    group: 'Sequencing',
  },
  seq_reply_status: {
    header: 'Reply Status',
    group: 'Sequencing',
  },
}

export const SEQUENCE_SORTABLE_FIELDS = [
  'seq_emails_sent',
  'seq_last_email',
  'seq_membership_status',
  'seq_scheduled_emails',
  'seq_replies',
]
